<template>
    <div class="main-wrapper">
        <b-navbar toggleable="xl">

            <img class="navbar__logo" src="@/assets/images/logo.png">

            <b-navbar-toggle target="nav-collapse"><i class="icon-menu"></i></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav align-h="end">

                <b-navbar-toggle target="nav-collapse"><i class="icon-close"></i></b-navbar-toggle>


                <b-navbar-nav>
                    <img class="navbar-nav__logo" src="@/assets/images/logo.png">
                    <b-nav-item to="/" exact>{{ $t("home") }}</b-nav-item>
                    <b-nav-item to="/pacotes/base" :active="isPacote">{{ $t("packages") }}</b-nav-item>
                    <b-nav-item to="/experiencias" :active="isExperiencia">{{ $t("experiences") }}</b-nav-item>

                    <div class="drop-menu">
                        <b-button href="#" variant="primary">{{ $t("reserve") }}</b-button>

                        <div class="drop-menu__wrapper">
                            <div class="drop-menu__body">
                                <b-button variant="primary" class="mb-2 mt-4 is--phone" href="tel:210312807">210 312 807</b-button>
                                <b-button variant="primary" class="mb-2 is--phone" href="tel:919878409">919 878 409</b-button>
                                <b-button variant="primary" class="mb-4 is--email" href="mailto:info@lismarketing.pt">info@lismarketing.pt</b-button>
                            </div>
                        </div>
                        
                    </div>


                    <div class="nav-item navbar-nav__bottom">
                        <div v-t="'reserveNow'"></div>
                        <div>
                            <a class="phone" href="tel:210312807">210 312 807</a>
                        </div>
                        <div>
                            <a class="phone" href="tel:919878409">919 878 409</a>
                        </div>
                        <div>
                            <a class="email" href="mailto:info@lismarketing.pt">info@lismarketing.pt</a>
                        </div>
                    </div>

                    <locale-changer></locale-changer>

                </b-navbar-nav>
                
            </b-collapse>
            <div class="mobile-bg"></div>
        </b-navbar>
    </div>
</template>

<script>
    import { BNavbar, BNavbarNav, BNavItem, BNavbarToggle, BCollapse } from 'bootstrap-vue';
    import LocaleChanger from '../../../components/LocaleChanger'

    export default {
        components: {
            BNavbar,
            BNavbarNav,
            BNavItem,
            BNavbarToggle,
            BCollapse,
            LocaleChanger
        },

        computed: {
            isPacote() {
                return this.$route.path.includes('pacotes');
            },
            isExperiencia() {
                return this.$route.path.includes('fado');
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.main-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
}

.navbar {
    background: $color-white;
    height: $navbar-height-desktop;

    @media (max-width: $breakpoint-large) {
        height: $navbar-height-mobile;
    }


    &__logo {
        position: absolute;
        z-index: 1;

        left: $main-side-margins;
        top: 1rem;
        

        @media (max-width: $breakpoint-large) {
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
        }
    }

    box-shadow: 0 2px 10px rgba(17, 25, 28, 1);
}

.nav-item {
    margin: 0.5rem;
}

  .navbar-nav {
        align-items: center;

        @media (max-width: $breakpoint-large) {
            align-items: flex-start;
        }

        &__logo {
            display: none;
            position: relative;
            max-width: 60px;
            margin: 2rem .5rem 1rem;

            @media (max-width: $breakpoint-large) {
                display: block;
            }
        }

        &__bottom {
            @media (min-width: $breakpoint-large) {
                display: none;
            }

            font-size: 1.375rem;
            font-weight: 400;

            a {
                font-size: 1.25rem;
                font-weight: 700;
                display: flex;
                align-items: center;

                line-height: 1.875rem;

                &::before {
                    margin-right: .625rem;
                    margin-top: 0.25rem;
                }

                &.phone {
                    &::before {
                        content: url('@/../../../../assets/images/icons/phone-white.svg');
                    }
                }

                &.email {
                    &::before {
                        content: url('@/../../../../assets/images/icons/envelope-white.svg');
                    }
                }
            }

            .phone,
            .email {
                margin: 0;
            }
        }

        .nav-link {
            color: $main-text-color;
            font-size: 1rem;
            font-weight: 600;

            &:hover,
            &:focus {
                color: $primary-color;
            }
        }
    }

.navbar-toggler {
    border: none;
    margin-right: auto;
}

.navbar-collapse {

    transition: none;
    justify-content: flex-end;
    text-align: left;
    padding: 0.5rem 3rem .5rem 1rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;

    min-width: 80%;
    
    @media (max-width: $breakpoint-large) {

        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        background: $color-white;
        z-index: 2;
    }

    &.show+.mobile-bg{
        display: block;
    }
}

.mobile-bg {
    display: none;
    background: rgba(0,0,0,.5);
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}

.drop-menu {
    position: relative;

    @media (max-width: $breakpoint-large) {
        display:none;
    }

    &:hover {
        .drop-menu__wrapper {
            display: block;
            
        }
    }

    &__wrapper {
        display: none;
        padding-bottom: 5px;
        position: absolute;
        right: 0;
        width: 100%;
    }

    &__body {
        position:absolute;
        right: 0;
        margin-top: 5px;

        text-align: center;

        padding: 0 1.25rem;
        background: white;
        box-shadow: 0 0 10px rgba(17, 25, 28, 0.2);
        border-radius: 0.3125rem;

        &:after {
            bottom: 100%;
            right: 5%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: all;
            border-bottom-color: white;
            border-width: 10px;
            margin-left: -10px;
            
        }

        h2 {
            font-size: 1.25rem;
            font-weight: 700;
            line-height: 2.4375rem;
            color: $main-text-color;
        }

        .btn {
            font-size: 1rem;
            padding: 0 1.75rem;
            white-space: nowrap;
            width: 100%;

            &:before {
                background: $color-white;
                height: 1.25rem;
                width: 1.25rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                margin-right: 0.625rem;
            }

            &.is--phone {
                &:before {
                    content: url("../../../assets/images/icons/phone.svg");
                }
            }

            &.is--email {
                &:before {
                    content: url("../../../assets/images/icons/envelope.svg");
                }
            }
        }
    }
}

.router-link-active, .active {
    border-bottom: solid 1px $primary-color;
}
</style>
